import React from "react";
import "kp-footer-pattern/dist/foundation.css";
import "footnote-pattern/dist/main.css";

const Footer: React.FC = () => {
  return (
        <footer className={`w-full bg-white mt-[148px]!`} role="contentinfo">
      <div className="grid-container max-w-7xl ">
        <div
          className="ds-footnotes w-full flex flex-col items-start justify-center"
          data-analytics-location="Footnotes"
          data-ds-theme="vessel"
          data-ds-variant="basic"
          data-ds-version="1"
        >
          <div
            className="ds-linklist mt-3!"
            data-ds-theme="vessel"
            data-ds-version="2"
            data-ds-variant="basic"
          >
            <nav
              className="flex flex-wrap items-center ds-linklist__list gap-2"
              aria-labelledby="link-list--0"
            >
              <a
                href="https://mykp.kp.org/en/admin/privacy-practices.html"
                data-analytics-type="link"
                data-analytics-click="Link 1"
                className="underline!"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Statement
              </a>
              <span className="text-gray-500">|</span>
              <a
                href="https://mykp.kp.org/en/admin/terms-and-conditions.html"
                data-analytics-type="link"
                data-analytics-click="Link 2"
                className="underline!"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms &amp; Conditions
              </a>
              <span className="text-gray-500">|</span>
              <a
                href="https://mykp.kp.org/en/content/help.html"
                data-analytics-type="link"
                data-analytics-click="Link 3"
                className="underline!"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Help
              </a>
            </nav>
          </div>
          <p style={{fontSize:'13px'}}>
            The material provided here is for informational purposes only.
Kaiser Permanente reserves the right to amend, replace, or terminate any benefit described on this site at its discretion, or through the negotiation process, if applicable. You will be advised of any significant changes in your benefit programs. All information on this website is subject to applicable laws and regulations described in the plan documents or contracts, and to applicable bargaining agreements and other governing documents. If there is any discrepancy, the language of the actual policies, contracts, plan documents, and/or bargaining agreements governs.
          </p>
        </div>
      </div>
      <div
        className="ds-kpfooter flex! items-center h-16!"
        data-ds-theme="vessel"
        data-ds-variant="simple"
        data-ds-version="3"
        data-analytics-location="kp-footer"
      >
        <div className="ds-grid__container">
          <div>
            <div className="ds-kpfooter__copyright copyright">
              <p className="text-center">
                © 2026 Kaiser Foundation Health Plan, Inc.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
